import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';

import type { PageQuery, PagedResult } from '@domain/models/paged-result.model';
import type { StoreComplaint } from '@domain/models/store.model';
import { StoreComplaintRepository } from '@domain/repositories/store-complaint.repository';

import type { ApiPagedResponse } from '@data/dto/api.dto';
import type { StoreComplaintDto } from '@data/dto/store.dto';
import { mapPagedComplaints, storeQueryParams } from '@data/mappers/store.mapper';

@Injectable()
export class StoreComplaintApiRepository extends StoreComplaintRepository {
  private readonly http = inject(HttpClient);
  private readonly path = 'api/complaints';

  list(query: PageQuery): Observable<PagedResult<StoreComplaint>> {
    const params = new HttpParams({
      fromObject: storeQueryParams(query) as Record<string, string | number>,
    });

    return this.http
      .get<ApiPagedResponse<StoreComplaintDto>>(this.path, { params })
      .pipe(map(mapPagedComplaints));
  }
}
